<template>
    <div v-if="invalidConnections.length !== 0">
        <v-popover popoverClass="connections-popover-content" popoverInnerClass="p-0" :offset="6">

            <slot name="trigger" :connections="invalidConnections"></slot>

            <template v-slot:popover>
                <AllAppsConnections
                    v-close-popover
                    :connections="invalidConnections"
                    @edit="onEdit"
                    @delete="onDelete"
                    class="w-100"/>
            </template>
        </v-popover>
        <AppAuthConnectionWrite name="connection-write" @updated="onUpdate"/>
    </div>
</template>

<script>
import axios from 'axios'
import AllAppsConnections from './AppsConnections'
import AppAuthConnectionWrite from '../AppAuthConnectionWrite'
import {withConfirmation} from '../../../../decorators/withConfirmation'
import {ConnectionStatuses} from '../../../../types/apps/connections'

export default {
    name: 'AppsConnectionsPopover',
    components: {AppAuthConnectionWrite, AllAppsConnections},
    data() {
        return {
            connections: []
        }
    },
    computed: {
        filteredConnections() {
            return this.connections.filter(c => c.app && c.app.uuid)
        },

        invalidConnections() {
            return this.filteredConnections.filter(c => c.status !== ConnectionStatuses.CONNECTED)
        }
    },
    methods: {
        async fetchConnections() {
            try {
                const res = await axios.get('automation/workflows/connections/all')
                const connections = _.isArray(_.get(res, 'data.data')) ? res.data.data : []
                this.connections = connections.filter(c => _.get(c, 'settings.appConnectionUuid'))
            } catch (e) {
                this.$raven.captureException(e)
            }
        },

        onUpdate(connection) {
            if (!connection || !connection.uuid) {
                return
            }
            const idx = this.connections.findIndex(c => c.uuid === connection.uuid)
            if (idx !== -1) {
                this.$set(this.connections, idx, connection)
            }
        },

        onDelete(connection) {
            withConfirmation({
                onConfirm: this.deleteConnection.bind(this, connection),
                title: 'Delete connection',
                description: `Do you want to delete "${connection.name}" connection?`
            })
        },

        deleteConnection(connection) {
            return axios.delete(`automation/workflows/connections/${this.appUuid}/${connection.uuid}`)
                .then(() => {
                    if (!connection || !connection.uuid) {
                        return
                    }
                    const idx = this.connections.findIndex(c => c.uuid === connection.uuid)
                    if (idx !== -1) {
                        this.$delete(this.connections, idx)
                    }
                })
        },

        onEdit(connection) {
            this.$modal.show('connection-write', {
                operation: 'edit',
                appUuid: _.get(connection, 'app.uuid'),
                authConnection: connection
            })
        }
    },
    created() {
        this.fetchConnections()
    }
}
</script>

<style lang="scss">
    .connections-popover-content {
        width: 360px !important;
        max-width: 360px !important;
        max-height: 400px;
        padding: 16px 24px;
        overflow-y: scroll;
    }
</style>
